<script setup>
import {computed} from 'vue'
import moment from 'moment'

const props = defineProps({
    column: Object,
    value: Number
})

const date = computed(() => {
    // todo - Hardcoded conversion of AngularJS date format to Moment.
    //  AngularJS https://docs.angularjs.org/api/ng/filter/date
    //  Moment https://momentjs.com/docs/#/displaying/
    //  Once all sites are upgraded to Vue I should run an upgrade script to convert the formats.
    let format
    switch (props.column.dateFormat) {
        case 'dd MMM yyyy':
            format = 'DD MMM YYYY'
            break
        case 'dd MMM yyyy, HH:mm':
        default:
            format = 'DD MMM YYYY, HH:mm'
    }

    return moment(props.value * 1000).format(format)
})
</script>

<template>
    <span v-if="value">{{ date }}</span>
</template>